export default __webpack_public_path__ + "svg/calendar/2026/3/abril.svg?c08f5bc2";